import { useEffect } from "react";
import axios from "axios";
import { store } from "../redux/storeOf";
import { BOM } from "../services/definedMethod";
import cnt from "../services/definedConstant";

/**
 * React hook to setup axios interceptors for 401 unauthorized errors
 * Only logs when both conditions are met:
 * 1. Response status is 401 Unauthorized
 * 2. User authentication token is present
 */
export const useAxiosSessionInterceptor = () => {
  useEffect(() => {
    // Response interceptor to catch and log 401 errors
    const interceptor = axios.interceptors.response.use(
      (response) => {
        // Return successful responses as-is
        return response;
      },
      (error) => {
        // console.log("error: ", typeof error);
        // Check if the error is a 401 Unauthorized
        const is401Error =
          // (error.response && error.response.status === 401) || error.message === "Network Error";
          error.response && error.response.status === 401;
        const state = store.getState();
        const userToken = state?.AuthenticationData?.userToken;
        if (is401Error && userToken) {
          BOM.AlertMsg(cnt.SUCCESS, "Session expired, please login again");
          console.error("🚨 401 Unauthorized Error Detected (with auth token)");
          window.location.href = "/sign-in";
          // Still reject the promise so calling code can handle it if needed
          return Promise.reject(error);
        } else {
          // Return/reject the error so it propagates to the calling code
          return Promise.reject(error);
        }
      },
    );

    // Cleanup: remove interceptor when component unmounts
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);
};
